import {connect} from '../../app/connect';
import ProjectView from './ProjectView';
import {trackEvent, changeLocationAction, setQueryParamsAction} from '../../app/actions';
import {
  canManageTemplates,
  getIsLoadingCurrentUserPermissions,
  isProjectSetupInProgress,
  isTemplatesViewEnabled
} from '../../app/selectors';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const mapStateToProps = (state, ownProps) => ({
  isLoadingCurrentUserPermissions: getIsLoadingCurrentUserPermissions(state),
  isTemplatesViewEnabled: isTemplatesViewEnabled(state) && canManageTemplates(state),
  selectedTabId: ownProps.route.selectedTabId,
  shouldShowProjectSetupInProgressPlaceholder:
    featureFlags.get(FEATURE_FLAGS.PROJECT_SETUP_IN_PROGRESS_EMPTY_STATE) && isProjectSetupInProgress(state)
});

const mapDispatchToProps = {
  trackEvent,
  changeLocationAction,
  setQueryParamsAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectView);
